import { render, staticRenderFns } from "./selfCreated.vue?vue&type=template&id=33e21e2e&scoped=true&"
import script from "./selfCreated.vue?vue&type=script&lang=js&"
export * from "./selfCreated.vue?vue&type=script&lang=js&"
import style0 from "./selfCreated.vue?vue&type=style&index=0&id=33e21e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e21e2e",
  null
  
)

export default component.exports